export type MapCoordinates = { lat?: number; lng?: number };

export function getLocationCoordinates(
  location?: {
    coordinates?: MapCoordinates;
    details?: { coordinates?: MapCoordinates };
  } | null
): MapCoordinates | undefined {
  if (!location) return undefined;
  return location.coordinates ?? location.details?.coordinates;
}

export function getGoogleMapsUrl(
  address?: string,
  coordinates?: MapCoordinates
): string | null {
  if (address?.trim()) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.trim())}`;
  }
  if (coordinates?.lat != null && coordinates?.lng != null) {
    return `https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`;
  }
  return null;
}
